import Highcharts from 'highcharts';
import highchartsSankeyInit from 'highcharts/modules/sankey';
import highchartsOrganizationInit from 'highcharts/modules/organization';
import highchartsAccessibilityInit from 'highcharts/modules/accessibility';

highchartsSankeyInit(Highcharts);
highchartsOrganizationInit(Highcharts);
highchartsAccessibilityInit(Highcharts);

document.addEventListener('DOMContentLoaded', () => {
  Highcharts.chart('container', {
    chart: {
      height: 250,
      inverted: true,
      adaptive: true,
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500,
        },
      }],
    },
    title: {
      text: null,
    },
    series: [{
      states: {
        inactive: {
          enabled: false,
        },
      },
      type: 'organization',
      keys: ['from', 'to'],
      data: [
        ['Sublevel 1', 'Sublevel 2'],
        ['Sublevel 1', 'Sublevel 3'],
        ['Sublevel 1', 'Sublevel 4'],
        ['Sublevel 1', 'Sublevel 5'],
        ['Sublevel 1', 'Sublevel 6'],
      ],
      levels: [{
        level: 0,
        color: '#005ea2',
        dataLabels: {
          style: {
            color: '#fff',
            cursor: 'pointer',
          },
        },
      }, {
        level: 1,
        y: 20,
        color: '#005ea2',
        dataLabels: {
          style: {
            color: '#fff',
            cursor: 'pointer',
          },
        },
      },
      ],
      nodes: [{
        id: 'Sublevel 1',
        name: 'Cybersecurity Program (CP)',
        events: {
          click() {
            document.getElementById('acc1').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc1').setAttribute('aria-expanded', true);
            document.getElementById('b-a1').removeAttribute('hidden');
          },
        },
      },
      {
        id: 'Sublevel 2',
        name: 'Identity, credential, and access management (ICAM)',
        height: 125,
        events: {
          click() {
            document.getElementById('acc2').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc2').setAttribute('aria-expanded', true);
            document.getElementById('b-a2').removeAttribute('hidden');
          },
        },
      },
      {
        id: 'Sublevel 3',
        name: 'Configuration, vulnerability, and update management (CVUM)',
        height: 125,
        events: {
          click() {
            document.getElementById('acc3').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc3').setAttribute('aria-expanded', true);
            document.getElementById('b-a3').removeAttribute('hidden');
          },
        },
      }, {
        id: 'Sublevel 4',
        name: 'Secure payment (SP)',
        height: 125,
        events: {
          click() {
            document.getElementById('acc4').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc4').setAttribute('aria-expanded', true);
            document.getElementById('b-a4').removeAttribute('hidden');
          },
        },
      }, {
        id: 'Sublevel 5',
        name: 'Secure communications (SC)',
        height: 125,
        events: {
          click() {
            document.getElementById('acc5').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc5').setAttribute('aria-expanded', true);
            document.getElementById('b-a5').removeAttribute('hidden');
          },
        },
      }, {
        id: 'Sublevel 6',
        name: 'Physical security (PS)',
        height: 125,
        events: {
          click() {
            document.getElementById('acc6').scrollIntoView({ behavior: 'smooth' });
            document.getElementById('acc6').setAttribute('aria-expanded', true);
            document.getElementById('b-a6').removeAttribute('hidden');
          },
        },
      },
      ],
      colorByPoint: false,
      borderColor: 'white',
      point: {
        events: {
          mouseOver() {
            this.update({
              color: '#B45008',
              borderColor: 'white',
            });
          },
          mouseOut() {
            this.update({
              color: '#005ea2',
              borderColor: 'white',
            });
          },
        },
      },
    }],
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    exporting: {
      allowHTML: true,
      sourceWidth: 800,
      sourceHeight: 600,
    },
  });
});
